@if ((reportingPeriodStateLoading$ | async) === false) {
  <div class="fpar-banner">
    @if (!submissionOpen && !validationOpen) {
      The data submission period is closed for any data submissions! Accepted
      data and previous year data submissions are available to view in the
      <span class="link" [routerLink]="['/table-archive']">Table Archive</span>.
    }
    @if (submissionOpen) {
      The FPAR 2.0 data portal is now open for testing 2026 FPAR data. Users
      should <span class="bold">not</span> submit data during this testing
      period. Any testing data uploaded during this period will be deleted in
      January, including uploaded files, table edits, and data quality comments.
    }
    @if (!submissionOpen && validationOpen) {
      The Data Validation Explorer tool is available for testing and/or training
      purposes only. It will remain available until the start of the submission
      period. Please note you will not be able to edit any tables and data will
      not be saved once the DVE tool is closed. You will need to resubmit your
      complete files during the open submission period.
    }
  </div>
}
